import api from './api';

export default {
  getJourneys() {
    return new Promise((resolve, reject) => {
      api
        .get('journey', {
          params: {
            includes: 'questionGroups',
            orderby: 'name,asc'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateJourney(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`journey/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addJourney(journey) {
    return new Promise((resolve, reject) => {
      api
        .post('journey', journey)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  attachCriteria(id, answerId) {
    return new Promise((resolve, reject) => {
      api
        .put(`journey/${id}/attach-criteria`, { answer_id: answerId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  detachCriteria(id, answerId) {
    return new Promise((resolve, reject) => {
      api
        .put(`journey/${id}/detach-criteria`, { answer_id: answerId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
